import { StepsButtons } from "@/components/button/steps-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { PageTitleComponent } from "@/components/page-title";
import { MealTimeSegmentButtons } from "@/components/segment-buttons/meal-time-segment-buttons";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { IonSkeletonText, useIonRouter } from "@ionic/react";
import { FormProvider } from "react-hook-form";
import { MealGroupList } from "../../components/meal-group-list";
import useGoToFoodProfile from "../../hooks/use-go-to-food-profile";

export default function OnboardingGoToFoodProfilePage() {
  const { info } = useStepRouteInfo();
  const navigation = useIonRouter();
  const {
    mealTime,
    form,
    handleFormSubmit,
    isGenerating,
    isValid,
    isLoading,
    getPreviousMealTimePath,
  } = useGoToFoodProfile({
    onSuccess: () => {
      navigation.push(info?.nextPath ?? "", "none");
    },
  });

  const onPreviousClick = () => {
    const previousMealTimePath = getPreviousMealTimePath();
    console.log("previousMealTimePath", previousMealTimePath);
    if (previousMealTimePath) {
      navigation.push(previousMealTimePath, "none");
    } else {
      navigation.push(info?.previousPath ?? "", "back");
    }
  };

  return (
    <ProfilePageContainer>
      <PageTitleComponent
        title="My Favourites"
        description="Add your favourite meals that you want to include in your meal plan."
      />

      <MealTimeSegmentButtons selected={mealTime} />
      <FormProvider {...form}>
        <form
          className="w-full flex-1 flex flex-col gap-4 justify-between"
          onSubmit={handleFormSubmit}
        >
          {isLoading ? (
            <div className="w-full flex flex-col gap-4">
              <IonSkeletonText animated className="h-16" />
              <IonSkeletonText animated className="h-16" />
              <IonSkeletonText animated className="h-16" />
              <IonSkeletonText animated className="h-16" />
            </div>
          ) : (
            <MealGroupList />
          )}

          <StepsButtons
            previousPath={info?.previousPath}
            onPreviousClick={onPreviousClick}
            type="submit"
            disabled={!isValid || isGenerating}
          />
        </form>
      </FormProvider>
    </ProfilePageContainer>
  );
}
